import { useStripe, useElements, CardElement } from "@stripe/react-stripe-js";
import { useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { updateAuth } from "../store/Reducers/authReducer"; // Adjust the import as needed
import { useReduxStore } from "../hooks/useReduxStore"; // Adjust the import as needed
import * as PaymentService from "../services/paymentService"; // Adjust the import as needed

const cardElementOptions = {
  style: {
    base: {
      color: "#ffffff",
      fontFamily: '"Outfit", "Inter", sans-serif',
      fontSize: "16px",
      "::placeholder": {
        color: "#71717a",
      },
      iconColor: "#FF8C21",
    },
    invalid: {
      color: "#ef4444",
      iconColor: "#ef4444",
    },
  },
};

const CheckoutForm = ({ amount = 10, id, handelModalType }) => {
  const stripe = useStripe();
  const elements = useElements();
  const { dispatch, getState } = useReduxStore();
  const { userData } = getState("AUTH");
  const { email, name } = userData || {};
  const [errorMessage, setErrorMessage] = useState("null");
  const [isEmpty, setIsEmpty] = useState(true);
  const [recaptchaToken, setRecaptchaToken] = useState(null);
  const [recaptchaError, setRecaptchaError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpMessage, setOtpMessage] = useState("");
  const [resendVisible, setResendVisible] = useState(false);
  const [resendVisible1, setResendVisible1] = useState(false);

  const onChangeCard = (obj) => {
    setErrorMessage(obj?.error?.message);
    setIsEmpty(obj?.empty);
  };

  const handleRecaptcha = (token) => {
    setRecaptchaToken(token);
    setRecaptchaError(null);
  };

  const isFormValid = () => {
    return !isEmpty && !errorMessage && recaptchaToken;
  };

  const handleSubmit = async (event) => {
    if (event) event.preventDefault();
    if (!recaptchaToken) {
      setRecaptchaError("Please complete the CAPTCHA");
      return;
    }
    try {
      if (elements == null) return;

      let elementError = await elements.submit();
      const { error: submitError } = elementError;
      if (submitError) return;

      handelModalType("loading");
      dispatch(updateAuth({ loading: true }));

      let { ok, data } = await PaymentService.createIntent({
        amount,
        name,
        email,
        recaptchaToken,
      });
      const { intent, amount: intentAmount } = data || {};

      if (ok && intent) {
        const { error } = await stripe.confirmCardPayment(intent, {
          payment_method: {
            card: elements.getElement(CardElement),
          },
        });

        if (error) {
          handelModalType("failed");
          setErrorMessage(error.message);
        } else {
          let { ok } = await PaymentService.paymentSuccess({
            product_id: id,
            payment_intent: intent,
            intent_amount: intentAmount,
          });
          if (ok) {
            handelModalType("success");
          } else {
            handelModalType("failed");
          }
        }
      } else {
        handelModalType("failed");
      }
    } catch (error) {
      handelModalType("failed");
    } finally {
      dispatch(updateAuth({ loading: false }));
    }
  };

  const handleVerifyOtp = async () => {
    try {
      const response = await fetch(
        "https://admin.bab-media.com/public/api/payment/otp/verify",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userData?.token}`,
          },
          body: JSON.stringify({ otp }),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to verify OTP");
      }

      const result = await response.json();
      setIsModalOpen(false);
      if (result.ok) {
        setErrorMessage("OTP verified successfully");
      } else {
        throw new Error(
          result.message || "Unknown error during OTP verification"
        );
      }
    } catch (error) {
      setErrorMessage(error.message);
    }
  };

  const handleResendOtp = async () => {
    try {
      const response = await fetch(
        "https://admin.bab-media.com/public/api/payment/otp/resend",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userData?.token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to resend OTP");
      }
      setResendVisible1(true);
      setOtpMessage(
        "An OTP has been resent to your email. It will expire within 5 minutes."
      );
      setTimeout(() => {
        setResendVisible1(false);
      }, 120000);
    } catch (error) {
      setErrorMessage(error.message);
    }
  };

  const handleContinue = async () => {
    setTimeout(() => {
      setResendVisible(true);
    }, 300000);
    try {
      const response = await fetch(
        "https://admin.bab-media.com/public/api/payment/otp/generate",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userData?.token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to send OTP");
      }

      setIsModalOpen(true);
    } catch (error) {
      setErrorMessage(error.message);
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="p-4 bg-[#111111] border border-gray-800 rounded-xl focus-within:border-secondary focus-within:ring-1 focus-within:ring-secondary transition-all">
          <CardElement onChange={onChangeCard} options={cardElementOptions} />
        </div>

        {recaptchaError && (
          <div>
            <p className="my-2 text-xs text-red-500 font-medium">
              {recaptchaError}
            </p>
          </div>
        )}
        {errorMessage === "OTP verified successfully" && (
          <div>
            <p className="my-2 text-xs text-green-500 font-medium">
              {errorMessage}
            </p>
          </div>
        )}

        <div className="flex justify-center md:justify-start">
          <ReCAPTCHA
            sitekey="6Le84TsqAAAAACaoQneF1ELV6M8LtgExgrcHGdPl"
            onChange={handleRecaptcha}
            theme="dark"
          />
        </div>

        {errorMessage === "OTP verified successfully" ? (
          <button
            type="button"
            onClick={handleSubmit}
            className="block w-full bg-secondary hover:bg-orange-500 text-white rounded-xl px-4 py-3 font-semibold transition-all hover:scale-[1.01] active:scale-95 shadow-md shadow-secondary/20 cursor-pointer text-center"
          >
            PAY NOW
          </button>
        ) : (
          <button
            type="button"
            onClick={handleContinue}
            className={`block w-full transition-all rounded-xl px-4 py-3 font-semibold text-center ${
              isFormValid()
                ? "bg-secondary hover:bg-orange-500 hover:scale-[1.01] active:scale-95 shadow-md shadow-secondary/20 cursor-pointer text-white"
                : "bg-gray-800 text-gray-500 cursor-not-allowed"
            }`}
            disabled={!isFormValid()}
          >
            CONTINUE
          </button>
        )}
      </form>

      {isModalOpen && (
        <div className="fixed inset-0 w-full h-full bg-black/80 backdrop-blur-sm flex justify-center items-center z-[1000] p-4 transition-all">
          <div className="bg-[#141414] border border-gray-800 text-white p-6 md:p-8 rounded-2xl text-center relative max-w-md w-full shadow-2xl animate-fade-in">
            <button
              className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors text-2xl font-bold"
              onClick={() => setIsModalOpen(false)}
            >
              &times;
            </button>
            <h3 className="font-bold text-xl md:text-2xl text-white mb-4">OTP Verification</h3>
            
            <div className="mb-4 mt-6 space-y-4">
              <div className="flex justify-center">
                <input
                  type="text"
                  value={otp}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    if (value.length <= 6) {
                      setOtp(value);
                    }
                  }}
                  placeholder="Enter 6-digit OTP"
                  className="bg-[#1e1e1e] border border-gray-850 text-white text-center rounded-xl px-4 py-3 w-3/4 text-lg font-bold tracking-widest focus:border-secondary focus:ring-1 focus:ring-secondary transition-all outline-none"
                  required
                  maxLength={6}
                />
              </div>
               
              <p className="text-xs text-gray-400">
                An OTP has been sent to your email. It will expire within 5 minutes.
              </p>

              {errorMessage !== "null" && errorMessage !== "OTP verified successfully" && (
                <div>
                  <p className="text-xs text-red-500 font-medium bg-red-500/10 border border-red-500/20 py-2 px-3 rounded-lg">
                    {errorMessage}
                  </p>
                </div>
              )}

              {otpMessage && (
                <div>
                  <p className="text-xs text-green-500 font-medium bg-green-500/10 border border-green-500/20 py-2 px-3 rounded-lg">
                    {otpMessage}
                  </p>
                </div>
              )}

              <div className="pt-2">
                <button
                  disabled={resendVisible1}
                  type="button"
                  onClick={handleResendOtp}
                  className={`text-xs font-medium transition-all ${
                    resendVisible1 
                      ? "text-gray-600 cursor-not-allowed"
                      : "text-secondary hover:underline cursor-pointer"
                  }`}
                >
                  Resend OTP
                </button>
              </div>

              <button
                type="button"
                onClick={handleVerifyOtp}
                className="block mt-6 w-full bg-secondary hover:bg-orange-500 text-white rounded-xl px-4 py-3 font-semibold transition-all hover:scale-[1.01] active:scale-95 shadow-md shadow-secondary/15"
              >
                VERIFY OTP
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CheckoutForm;
